'use client';

import { useEffect, useRef } from 'react';

import { cn } from '@/utils/utils';

export default function VideoPlayer({
  src,
  poster,
  title,
  className,
}: {
  src: string;
  poster?: string | null;
  title: string;
  className?: string;
}) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const seekTo = Number(new URLSearchParams(window.location.search).get('t'));
    if (!Number.isFinite(seekTo) || seekTo < 0) return;
    const seek = () => {
      if (seekTo <= video.duration || !Number.isFinite(video.duration)) video.currentTime = seekTo;
    };
    if (video.readyState >= 1) seek();
    else video.addEventListener('loadedmetadata', seek, { once: true });
    return () => video.removeEventListener('loadedmetadata', seek);
  }, [src]);

  return (
    <div className={cn('overflow-hidden rounded-xl bg-[#07111f] shadow-[0_24px_70px_rgba(16,35,63,.18)]', className)}>
      <video
        ref={videoRef}
        className="aspect-video h-auto w-full bg-black object-contain"
        controls
        playsInline
        preload="metadata"
        poster={poster || undefined}
        aria-label={title}
      >
        <source src={src} type="video/mp4" />
        Your browser does not support HTML5 video. <a href={src}>Open the MP4 file</a>.
      </video>
    </div>
  );
}
